import Primary from '../layouts/Primary'
import Home from '../views/Home'
import Login from '../views/user/Login'
import BeOurPartner from '@/views/Partner'

export const pagesRouter = {
  path: '',
  name: 'primary',
  component: Primary,
  redirect: '/payday-loan',
  children: [
    {
      path: '/payday-loan',
      name: 'home',
      component: Home
    },
    {
      path: '/personal-loans',
      name: 'personal_loans',
      component: Home
    },
    {
      path: '/purchasing-service',
      name: 'purchasing_service',
      component: Home
    },
    {
      path: '/pawn-service',
      name: 'pawn_service',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/be-our-partner',
      name: 'our-partner',
      component: BeOurPartner
    }
  ]
}
